import { createApp, h } from "vue";
import Index from "./index.vue";
import "./plugins/arms.ts";
import direct from "./plugins/direct";
import message from "./plugins/message";
import router from "./plugins/router";
import wechat from "./plugins/wechat";

const app = createApp({
  data() {
    return {
      vConsole: null,
    };
  },
  render() {
    return h(Index);
  },
  // async created() {
  //   if (!import.meta.env.DEV) return;
  //   const vconsole = await import("vconsole");
  //   this.vConsole = new vconsole.default();
  // },
});

app.use(router);
app.use(direct);
app.use(message);
app.use(wechat);
app.mount("#app");
